import {Component, Input, OnInit} from '@angular/core';
import {CardapioService} from "../../services/cardapio.service";
import {VitrinesService} from "../../superadmin/services/vitrines.service";
import {RotaGuardClient} from "../../guards/auth-loja.guard";

// Configuracao do destaque exibido quando o cliente abre o cardapio. Vive aqui no
// compartilhado porque as duas telas de produtos abrem este dialog, e a tela de
// Vitrines continua com a mesma configuracao no formato inline dela.
@Component({
  selector: 'app-ofertas-boas-vindas',
  templateUrl: './ofertas-boas-vindas.component.html',
  styleUrls: ['./ofertas-boas-vindas.component.scss']
})
export class OfertasBoasVindasComponent implements OnInit {
  @Input() empresa: any = {};
  // produtos crus da tela que abriu o dialog: a previa mostra as ofertas de verdade
  // da loja, e nao um exemplo generico que nao serve para todo segmento
  @Input() produtos: any[] = [];

  windowRef: any;
  window: any;

  exibir = true;
  fonte: 'auto' | 'vitrine' = 'auto';
  vitrineId: number = null;
  formato = 'SHEET';

  vitrines: any[] = [];
  temRecursoVitrines = false;
  carregandoVitrines = false;
  salvando = false;
  erro: string;

  ofertas: any[] = [];
  totalOfertas = 0;
  economiaTotal = 0;
  private imagensComErro: any = {};

  constructor(private cardapioService: CardapioService,
              private vitrinesService: VitrinesService) {
  }

  ngOnInit() {
    const cardapio = this.empresa && this.empresa.cardapio ? this.empresa.cardapio : null;

    this.exibir = !cardapio || cardapio.exibirDestaqueAbertura !== false;
    this.vitrineId = cardapio && cardapio.vitrineAberturaId ? cardapio.vitrineAberturaId : null;
    this.fonte = this.vitrineId ? 'vitrine' : 'auto';
    this.formato = (cardapio && cardapio.formatoDestaqueAbertura) || 'SHEET';

    this.temRecursoVitrines = RotaGuardClient.possuiRecurso({empresa: this.empresa}, 'vitrines');

    // tambem carrega sem o recurso quando ja existe uma vitrine configurada: a loja
    // continua exibindo ela, entao a previa mentiria se ignorasse
    if(this.temRecursoVitrines || this.vitrineId) this.carregueVitrines();

    this.calculeOfertas();
  }

  private carregueVitrines() {
    this.carregandoVitrines = true;

    this.vitrinesService.listeVitrines().then((vitrines: any) => {
      this.vitrines = vitrines || [];
      this.carregandoVitrines = false;
      this.calculeOfertas();
    }).catch(() => {
      this.vitrines = [];
      this.carregandoVitrines = false;
    });
  }

  alterneExibicao() {
    this.salveConfig({exibirDestaqueAbertura: !this.exibir}, () => this.exibir = !this.exibir);
  }

  useFonte(fonte: 'auto' | 'vitrine') {
    if(this.fonte === fonte) return;

    // "uma vitrine" sem nenhuma escolhida ainda: so muda o modo, o id vai no select
    const novoId = fonte === 'auto' ? null : this.primeiraVitrineDisponivel();

    this.salveConfig({vitrineAberturaId: novoId}, () => {
      this.fonte = fonte;
      this.vitrineId = novoId;
      this.calculeOfertas();
    });
  }

  useVitrine(id: any) {
    const novoId = id ? Number(id) : null;

    this.salveConfig({vitrineAberturaId: novoId}, () => {
      this.vitrineId = novoId;
      this.calculeOfertas();
    });
  }

  useFormato(formato: string) {
    if(this.formato === formato) return;

    this.salveConfig({formatoDestaqueAbertura: formato}, () => this.formato = formato);
  }

  feche() {
    const ref = this.windowRef || this.window;

    if(ref) ref.close();
  }

  private primeiraVitrineDisponivel() {
    const vitrine = this.vitrines.find((item: any) => item && item.disponivel) || this.vitrines[0];

    return vitrine ? vitrine.id : null;
  }

  // Salvamento otimista: aplica na tela, manda so o campo alterado e desfaz se o
  // servidor recusar. /cardapio/atualize faz Object.assign no cardapio do banco,
  // entao mandar o cardapio inteiro daqui empurraria valores velhos do cache.
  private salveConfig(patch: any, aplique: () => void) {
    if(this.salvando) return;

    const anterior = {
      exibir: this.exibir,
      fonte: this.fonte,
      vitrineId: this.vitrineId,
      formato: this.formato
    };

    aplique();

    this.salvando = true;
    this.erro = null;

    this.cardapioService.atualizeConfiguracoesCardapio(patch).then((cardapio: any) => {
      this.salvando = false;

      // o objeto de empresa e o mesmo que o ConstantsService guarda: mutar o
      // cardapio aqui ja vale para as telas que o leem depois
      if(this.empresa)
        this.empresa.cardapio = Object.assign(this.empresa.cardapio || {}, patch, cardapio || {});
    }).catch((erro: any) => {
      this.salvando = false;
      this.exibir = anterior.exibir;
      this.fonte = anterior.fonte;
      this.vitrineId = anterior.vitrineId;
      this.formato = anterior.formato;
      this.calculeOfertas();
      // ServerService.handleError rejeita com string, nao com Error
      this.erro = erro && erro.message ? erro.message :
        (erro || 'Não foi possível salvar. Tente de novo.');
    });
  }

  // Mesma regra da loja (ProdutosTelaUtils/site-produtos): destaque no produto ou em
  // algum tamanho, indisponiveis fora, maior desconto primeiro.
  private calculeOfertas() {
    const lista = this.fonte === 'vitrine' ?
      this.produtosDaVitrine() : this.produtosEmDestaque();

    const ordenados = lista.sort((a: any, b: any) => {
      const porDesconto = this.percentualDesconto(b) - this.percentualDesconto(a);
      if(porDesconto !== 0) return porDesconto;

      return (this.obtenhaImagem(b) ? 1 : 0) - (this.obtenhaImagem(a) ? 1 : 0);
    });

    this.totalOfertas = ordenados.length;
    this.ofertas = ordenados.slice(0, 3);
    this.economiaTotal = this.ofertas.reduce(
      (total: number, produto: any) => total + this.economia(produto), 0);
  }

  private produtosDaVitrine() {
    const vitrine = this.vitrines.find(
      (item: any) => Number(item.id) === Number(this.vitrineId));

    return ((vitrine && vitrine.produtosNaVitrine) || [])
      .map((produtoNaVitrine: any) => produtoNaVitrine.produto)
      .filter((produto: any) => produto && !produto.indisponivel);
  }

  private produtosEmDestaque() {
    const vistos: any = {};

    return (this.produtos || []).filter((produto: any) => {
      if(!produto || produto.indisponivel || produto.naodisponivel) return false;
      if(vistos[produto.id]) return false;
      if(!this.estaEmDestaque(produto)) return false;

      vistos[produto.id] = true;

      return true;
    });
  }

  private estaEmDestaque(produto: any) {
    const naEmpresa = produto.produtoNaEmpresa ? produto.produtoNaEmpresa.destaque : null;
    const destaqueNaEmpresa = naEmpresa != null ? naEmpresa : produto.destaqueNaEmpresa;

    if(destaqueNaEmpresa != null) return !!destaqueNaEmpresa;
    if(produto.destaque) return true;

    return (produto.tamanhos || []).some((tamanho: any) => tamanho && tamanho.destaque);
  }

  obtenhaImagem(produto: any) {
    const link = produto && produto.imagens && produto.imagens.length ?
      produto.imagens[0].linkImagem : (produto ? (produto.linkImagem || produto.imagem) : null);

    if(!link) return null;
    if(/^https?:\/\//i.test(link)) return link;

    return '/images/empresa/' + String(link).replace(/^\/+/, '');
  }

  temImagem(produto: any) {
    return !!this.obtenhaImagem(produto) && !this.imagensComErro[produto.id];
  }

  marqueImagemComErro(produto: any) {
    this.imagensComErro[produto.id] = true;
  }

  obtenhaPreco(produto: any) {
    return produto.valorMinimo ? produto.valorMinimo : produto.preco;
  }

  percentualDesconto(produto: any) {
    const preco = Number(this.obtenhaPreco(produto) || 0);
    const precoAntigo = Number(produto.precoAntigo || 0);

    if(!preco || !precoAntigo || precoAntigo <= preco) return 0;

    return Math.round((1 - (preco / precoAntigo)) * 100);
  }

  economia(produto: any) {
    const preco = Number(this.obtenhaPreco(produto) || 0);
    const precoAntigo = Number(produto.precoAntigo || 0);

    return precoAntigo > preco ? precoAntigo - preco : 0;
  }

  descricaoCurta(produto: any) {
    const descricao = String(produto && produto.descricao || '').trim();

    if(descricao.length <= 60) return descricao;

    const corte = descricao.slice(0, 60);
    const ultimoEspaco = corte.lastIndexOf(' ');

    return (ultimoEspaco > 36 ? corte.slice(0, ultimoEspaco) : corte)
      .replace(/[\s,;:.\-]+$/, '');
  }

  get vitrineEscolhidaVazia() {
    return this.fonte === 'vitrine' && !this.carregandoVitrines && !this.totalOfertas;
  }
}
